import { render, staticRenderFns } from "./RTrainingDemand.vue?vue&type=template&id=47474cd8&scoped=true"
import script from "./RTrainingDemand.vue?vue&type=script&lang=js"
export * from "./RTrainingDemand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47474cd8",
  null
  
)

export default component.exports